import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetitemsimportpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetItemImportPage } = await import(
        /* webpackChunkName: "Login" */ '../../../components/pages/private/BudgetItemsImportPage'
      )
      return {
        default: BudgetItemImportPage,
      }
    })}
    exact
    key={paths.budgetItemsImport}
    path={paths.budgetItemsImport}
  />,
]
